'use client';

import { useState } from 'react';
import Image from 'next/image';
import { IconChevronLeft, IconArrowRight } from './DesignIcons';

const testimonials = [
  {
    id: 1,
    name: 'Priya S',
    role: 'Parent',
    quote: 'The 6 steps gave me clarity and helped me manage my emotions better. My life has truly changed for the better.',
    avatar: '/images/new_design/avatar_priya.jpg',
  },
  {
    id: 2,
    name: 'Ramesh N',
    role: 'Corporate Participant',
    quote: 'The sessions were engaging and practical. Our team is more focused and positive now.',
    avatar: '/images/new_design/avatar_ramesh.jpg',
  },
  {
    id: 3,
    name: 'Ananya',
    role: 'College Student',
    quote: 'This program gave me confidence and helped me see life in a new way.',
    avatar: '/images/new_design/avatar_ananya.jpg',
  },
  {
    id: 4,
    name: 'Karthik V',
    role: 'School Principal',
    quote: 'Our students gained emotional balance and clarity on their future goals through Dr. (H.C.) Shyam Kumar’s sessions.',
    avatar: '/images/new_design/avatar_ramesh.jpg',
  },
  {
    id: 5,
    name: 'Meera R',
    role: 'Individual Transformation',
    quote: 'Moving from illusion to reality helped me overcome years of anxiety. Highly recommended.',
    avatar: '/images/new_design/avatar_priya.jpg',
  },
];

export default function TestimonialSlider() {
  const [startIndex, setStartIndex] = useState(0);

  const handlePrev = () => {
    setStartIndex((prev) => (prev === 0 ? testimonials.length - 3 : prev - 1));
  };

  const handleNext = () => {
    setStartIndex((prev) => (prev >= testimonials.length - 3 ? 0 : prev + 1));
  };

  // Get current 3 visible items
  const visibleTestimonials = [
    testimonials[startIndex % testimonials.length],
    testimonials[(startIndex + 1) % testimonials.length],
    testimonials[(startIndex + 2) % testimonials.length],
  ];

  return (
    <div className="testimonials-wrapper">
      {/* Slider Nav Buttons */}
      <button
        type="button"
        className="testimonial-nav-btn prev-btn"
        onClick={handlePrev}
        aria-label="Previous testimonials"
      >
        ‹
      </button>

      {/* Cards Container */}
      <div className="testimonials-cards-grid">
        {visibleTestimonials.map((item, idx) => (
          <div key={`${item.id}-${idx}`} className="testimonial-card">
            <div className="testimonial-avatar-col">
              <div className="avatar-img-wrap">
                <Image
                  src={item.avatar}
                  alt={item.name}
                  width={68}
                  height={68}
                  className="avatar-photo"
                />
              </div>
            </div>

            <div className="testimonial-content-col">
              <span className="quote-mark">“</span>
              <p className="testimonial-text">
                {item.quote}”
              </p>
              <div className="testimonial-author">
                <span className="author-name">— {item.name}</span>
                <span className="author-role">{item.role}</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      <button
        type="button"
        className="testimonial-nav-btn next-btn"
        onClick={handleNext}
        aria-label="Next testimonials"
      >
        ›
      </button>
    </div>
  );
}
